import { useTranslation } from 'react-i18next';
import type { ItemHealth } from '@/common/api/types/dashboard/health';
import { DependencyIndicator } from '@/features/item-panel/components/tabs/dependencies/DependencyIndicator';
import type { ItemsTableRow } from '@/features/items/components/table/types';

export const DependencySuccessorCell = ({
  row,
  currentItemId,
  healthByItemId,
}: {
  row: ItemsTableRow;
  currentItemId: number;
  healthByItemId: Map<number, ItemHealth | undefined>;
}) => {
  const { t } = useTranslation();
  const rowHealth = healthByItemId.get(row.id);
  const isBlocking =
    rowHealth?.dependency?.blockedByPredecessorIds.includes(currentItemId) ?? false;
  const isAtRisk =
    !isBlocking && (rowHealth?.dependency?.atRiskPredecessorIds.includes(currentItemId) ?? false);

  return (
    <DependencyIndicator
      isError={isBlocking}
      isWarning={isAtRisk}
      tooltip={
        isBlocking
          ? t(($) => $.adaptivePlanner.itemPanel.dependenciesSection.blockingTooltip)
          : t(($) => $.adaptivePlanner.itemPanel.dependenciesSection.atRiskBlockingTooltip)
      }
      alertDotTestId="successor-alert-dot"
    />
  );
};
